<template>
  <v-dialog
    v-model="dialog"
    max-width="550px"
  >
    <v-card>
      <!-- HEADER -->
      <v-card-title class="d-flex flex-row align-center justify-space-between">
        <div class="text-h6">
          Release Details
        </div>
        <div class="d-flex align-center  w-100 mt-1">
          <div class="text-caption">
            Created: {{ formattedDate }}
          </div>
        </div>
      </v-card-title>
      <v-divider />
      <!-- BODY -->
      <v-card-text v-if="release">
        <!-- VERSION SECTION -->
        <div class="mb-4">
          <div class="mb-2">
            Versions
          </div>
          <v-row dense>
            <v-col cols="4">
              <v-sheet
                outlined
                rounded
                class="pa-2 text-center"
              >
                <div class="">
                  Engine
                </div>
                <div class="font-weight-medium">
                  {{ release.engine_version || '—' }}
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet
                outlined
                rounded
                class="pa-2 text-center"
              >
                <div class="">
                  POS
                </div>
                <div class="font-weight-medium">
                  {{ release.pos_version || '—' }}
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet
                outlined
                rounded
                class="pa-2 text-center"
              >
                <div class="">
                  KDS
                </div>
                <div class="font-weight-medium">
                  {{ release.kds_version || '—' }}
                </div>
              </v-sheet>
            </v-col>
            <v-col cols="4">
              <v-sheet
                outlined
                rounded
                class="pa-2 text-center"
              >
                <div class="">
                  Kiosk
                </div>
                <div class="font-weight-medium">
                  {{ release.kiosk_version || '—' }}
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </div>
        <!-- RELEASE NOTES -->
        <div>
          <div class="mb-2">
            Release Notes
          </div>
          <v-sheet
            outlined
            rounded
            class="pa-3"
            style="max-height: 200px; overflow-y: auto;"
          >
            <v-sheet
              v-if="parsedNotes.length"
              class="pa-3"
            >
              <div
                v-for="(note, i) in parsedNotes"
                :key="i"
                class="d-flex align-start ga-3"
                :class="{ 'mb-2': i < parsedNotes.length - 1 }"
                style="max-height: 300px; overflow-y: auto;"
              >
                <div v-if="note.tag">
                  <b>{{ note.tag }} </b>- &nbsp;
                </div>
                <span class="text-body-2">{{ note.text }}</span>
              </div>
            </v-sheet>
            <div
              v-else
              class="-"
            >
              No release notes provided.
            </div>
          </v-sheet>
        </div>
      </v-card-text>
      <!-- FOOTER -->
      <v-divider />
      <v-card-actions class="justify-end">
        <v-btn
          color="error"
          class="white--text"
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      release: null
    };
  },
  computed: {
    formattedDate() {
      if (!this.release?.created_at) return "—";
      return new Date(this.release.created_at).toLocaleDateString("en-US", {
        year: "numeric", month: "long", day: "numeric"
      });
    },
    parsedNotes() {
      if (!this.release?.notes) return [];
      return this.release.notes
        .split("\n")
        .filter((l) => l.trim())
        .map((line) => {
          const match = line.match(/^\*\*(New|Fixed|Improved|Breaking)\*\*\s*[—-]\s*(.+)$/i);
          if (match) return { tag: match[1], text: match[2].trim() };
          return { tag: null, text: line.trim() };
        });
    }
  },
  methods: {
    open(item) {
      this.release = item;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>